import { useState, useEffect } from 'react';

import { getGuidebooks } from '../../utils/utils.js';
import Loading from '../Loading';
import Page from '../Page.js';
import { Link } from 'react-router-dom';
import { GuidebookCard } from './FeaturedGuidebooks.js';

let Guidebooks = () => {
  let [guideBooks, setGuideBooks] = useState([]);
  let [loading, setLoading] = useState(false);
  useEffect(() => {
    async function fetch() {
      setLoading(true);
      let guideBooks = await getGuidebooks();

      setGuideBooks(guideBooks);
      setLoading(false);
    }
    fetch();
  }, []);

  return (
    <Page>
      <GuidebooksBreadcrumb />
      <h1>Guidebooks</h1>
      {loading && <Loading />}

      <div className="grid grid-cols-3 gap-6">
        {guideBooks.length > 0 ? (
          guideBooks.map((guidebook) => {
            if (guidebook.acf.guidebook_published) {
              return <GuidebookCard key={guidebook.id} guidebook={guidebook} />;
            } else {
              return null;
            }
          })
        ) : (
          <p>No guidebooks found.</p>
        )}
      </div>
    </Page>
  );
};

let GuidebooksBreadcrumb = () => {
  return (
    <div className="text-sm">
      <Link reloadDocument to="/library">
        Library
      </Link>{' '}
      <span className="mx-2">/</span> Guidebooks
    </div>
  );
};

export default Guidebooks;
